// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"6778":"059c29a40152f2f6afcf","7795":"b8fac4e2fb250d9e3bef","8826":"3c9b523bfa4c4940e4d8"}[chunkId] + ".css";
};